import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../../commonDesign/SydModal'
import SydButton from '../../../../../../commonDesign/Button'

function ProblemDetailModal ({
  onClose,
  onForce,
  problemDetail
}) {
  const {
    title = 'There was a problem processing your request'
    , detail, canForce, forceLabel = 'Continue'
  } = problemDetail ?? {}

  return (
    <SydModal
      open={!!problemDetail}
      onClose={onClose}
      title={title}
      subtitle={detail}
    >
      {canForce && (
        <div>
          <SydButton variant='primary' onClick={onForce}>
            {forceLabel}
          </SydButton>
        </div>
      )}
    </SydModal>
  )
}

ProblemDetailModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onForce: PropTypes.func.isRequired,
  problemDetail: PropTypes.shape({
    title: PropTypes.string,
    detail: PropTypes.string,
    canForce: PropTypes.bool
  })
}

export default ProblemDetailModal
